import { Typography, Alert as AlertMaterial, IconButton } from '@mui/material';
import { Box, SxProps } from '@mui/system';

export const Alert = ({
    message,
    isSuccess,
    clearMessage,
    style
}: {
    isSuccess: boolean;
    message: string | undefined;
    clearMessage?: () => void;
    style?: SxProps;
}) => {
    return (
        <>
            {message && (
                <Box sx={{ my: 2, width: '100%', ...style }}>
                    <AlertMaterial
                        sx={{}}
                        severity={isSuccess ? 'success' : 'error'}
                        action={
                            <IconButton size="small" onClick={clearMessage}>
                                <i className="far fa-times" style={{ fontSize: 18 }} />
                            </IconButton>
                        }
                    >
                        <Typography variant="caption" sx={{ fontWeight: 400 }}>
                            {message}
                        </Typography>
                    </AlertMaterial>
                </Box>
            )}
        </>
    );
};
